<div class="px-6">
  <p-toast position="top-right" key="toastError"></p-toast>
  <p-toast position="top-right" key="toastSuccess"></p-toast>
  <p-card styleClass="my-3">
    <p-fieldset legend="Filtros" [toggleable]="true">
      <div class="grid mt-3">
        <div class="col-6">
          <span class="p-float-label">
            <p-dropdown
              [scrollHeight]="'30rem'"
              [style]="stylePattern"
              [options]="contracts"
              inputId="filtroGrupos"
              [required]="true"
              [readonly]="true"
              optionLabel="description"
              optionValue="id"
              [(ngModel)]="occurrenceFilter.contractId"
              [filter]="true"
              [disabled]="true"
              placeholder="Selecionar"
              dropdownIcon="null"
              (onChange)="getMotives();getOperations()"
            >
              <ng-template let-grupos pTemplate="item">
                <div class="font-semibold text-center">
                  {{ grupos.description }}
                </div>
              </ng-template>
            </p-dropdown>
            <label htmlFor="filtroGrupos">Contrato</label>
          </span>
        </div>
        <!-- <div class="col-3">
          <span class="p-float-label">
            <p-dropdown
              [options]="occurrenceType"
              [(ngModel)]="occurrenceFilter.type"
              optionLabel="name"
              optionValue="value"
              [style]="stylePattern"
              [showClear]="true"
              inputId="filterAgrupador"
              placeholder="Selecionar"
            ></p-dropdown>
            <label htmlFor="filterAgrupador">Agrupador</label>
          </span>
        </div> -->
        <div class="col-6">
          <span class="p-float-label">
            <p-dropdown
              [options]="motives"
              [(ngModel)]="occurrenceFilter.motiveOccurrence"
              optionLabel="description"
              optionValue="id"
              [style]="stylePattern"
              inputId="filterMotivo"
              [disabled]="!occurrenceFilter.contractId"
              emptyMessage="Sem Motivos Cadastrados">
          </p-dropdown>
            <label htmlFor="filterMotivo">Motivo</label>
          </span>
        </div>
    </div>
      <!-- <div class="grid mt-3">
        <div class="col-12">
          <span class="p-float-label">
            <p-dropdown
            [(ngModel)]="occurrenceFilter.operation"
            [filter]="true"
            [showClear]="true"
            [options]="operations"
            optionLabel="operation"
            optionValue="id"
            [style]="stylePattern"
            inputId="filterOperacao"
            placeholder="Selecionar"
            [disabled]="!occurrenceFilter.contractId"
            ></p-dropdown>
            <label htmlFor="filterOperacao">Operação</label>
          </span>
        </div>
      </div> -->
      <div class="grid mt-3">
        <div class="col-3">
          <span class="p-float-label">
            <p-calendar
              [style]="stylePattern"
              selectionMode="range"
              [readonlyInput]="true"
              inputId="filterRange"
              [class]="!verifyVariables() ? 'ng-invalid ng-dirty' : ''"
              [(ngModel)]="rangeDates"
              [maxDate]="maxDate"
            ></p-calendar>
            <label htmlFor="filterRange">Intervalo</label>
          </span>
        </div>
        <div class="col-3">
          <p-multiSelect
            *ngIf="lotes.length > 0"
            [options]="lotes"
            [(ngModel)]="selectedLotes"
            (ngModelChange)="loteModelChanges($event)"
            [maxSelectedLabels]="lotes.length"
            selectedItemsLabel="{0} Lotes selecionados"
            optionLabel="description"
            optionValue="id"
            styleClass="lote-multiselect"
            [style]="stylePattern"
            display="chip"
            [showToggleAll]="false"
            [filter]="true"
            [showClear]="true"  
            placeholder="Lote"
          >
            <ng-template let-lote pTemplate="item">
              <div class="font-semibold text-center">
                {{ lote.description }}
          </div>
            </ng-template>
          </p-multiSelect>
        </div>
        <div class="col-3">
          <span class="p-float-label" [class.p-inputwrapper-filled]="occurrenceFilter.device && occurrenceFilter.device.length > 0">
            <p-multiSelect
              [(ngModel)]="occurrenceFilter.device"
              [options]="devices"
              optionLabel="deviceName"
              optionValue="deviceId"
              [style]="stylePattern"
              inputId="filterDevice"
              selectedItemsLabel="{0} Equipamentos selecionados"
              [scrollHeight]="'30rem'"
              [filter]="true"
              [showClear]="true"
              placeholder="Selecionar"
            >
              <ng-template let-device pTemplate="item">
                <div class="font-semibold text-center">
                  {{ device.deviceName }}
                </div>
              </ng-template>
            </p-multiSelect>
            <label htmlFor="filterDevice">Equipamento</label>
          </span>
        </div>
        <div class="col-3">
          <span class="p-float-label">
          <p-dropdown
            [(ngModel)]="occurrenceFilter.lane"
            [filter]="true"
            [showClear]="true"
            [style]="stylePattern"
            [options]="lanes"
            inputId="filterLane"
            placeholder="Selecionar"
            >
          </p-dropdown>
          <label htmlFor="filterLane">Pista</label>
          </span>
        </div>
      </div>
      <div class="flex align-items-center gap-4 mt-3">
        <p-checkbox label="Apenas com anexo" pTooltip="Exibe somente ocorrências que possuem arquivos anexados." [(ngModel)]="occurrenceFilter.hasAttachment" [binary]="true"></p-checkbox>
        <p-checkbox label="Apenas com anotações" pTooltip="Exibe somente ocorrências que possuem anotações." [(ngModel)]="occurrenceFilter.hasNotes" [binary]="true"></p-checkbox>
      </div>
      <div class="grid mt-3">
        <!-- <div class="col-3">
          <p-checkbox label="Rejeitado Pelo Orgão" [(ngModel)]="occurrenceFilter.rejected" [binary]="true"></p-checkbox>
        </div> -->
        <div class="col-4 flex text-align: right;">
          <p-button
            class="block relative mr-2 top-100 -translate-y-100"
            [style]="{ height: '40px' }"
            [disabled]="!verifyVariables()"
            label="Filtrar"
            (onClick)="getOccurrence(false, occurrenceFilter)"
            size="small"
            icon="pi pi-search"
          ></p-button>
          <p-button label="Primary" [outlined]="true"
            class="block relative top-100 -translate-y-100"
            [style]="{ height: '40px' }"
            label="Limpar Filtro"
            size="small"
            icon="pi pi-times"
            (click)="clearFilter()"
          ></p-button>
        </div>
      </div>
    </p-fieldset>
  </p-card>
  <p-card [styleClass]="!notFound ? '' : 'mb-3'">
    <p-toolbar [styleClass]="!notFound ? 'mb-4 gap-2' : ''">
      <ng-template pTemplate="left">
          <button pButton pRipple label="Nova Ocorrência" icon="pi pi-plus" class="p-button-primary mr-2" (click)="goToNewOccurrence()"></button>
      </ng-template>
      <ng-template pTemplate="right">
        <button
          pButton
          pRipple
          [label]="exportReady ? 'Baixar' : 'Exportar'"
          [icon]="exportLoading ? 'pi pi-spin pi-spinner' : exportReady ? 'pi pi-download' : 'pi pi-file-excel'"
          [disabled]="exportLoading || notFound"
          class="p-button-success"
          (click)="exportReady ? downloadExport() : exportOccurrences()"
        ></button>
      </ng-template>
    </p-toolbar>
    <p-table
    #dt1
    *ngIf="!notFound"
    [(first)]="first"
    [value]="occurrenceData"
    [totalRecords]="totalRecords"
    [loading]="loading"
    [lazy]="true"
    [tableStyle]="{ 'min-width': '100%' }"
    [paginator]="true"
    [rows]="50"
    [rowsPerPageOptions]="[50, 100, 150, 200]"
    (onLazyLoad)="onLazyLoad($event)"
    >
      <ng-template pTemplate="header">
        <tr>
          <th
            *ngFor="let col of columns"
            class="text-center"
            (click)="customSort(col.field)"
            style="cursor: pointer; position: relative;"
            [style.width]="col.width">
            <b>{{ col.label }}</b>
            <i class="pi ml-2"
               [ngClass]="getSortIconClass(col.field)"
               style="display: inline-block; width: 1rem; text-align: center;"></i>
          </th>

          <th class="text-center">
            <b>Ações</b>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-mOccurrence>
        <tr [style]="{ cursor: 'default' }">
          <td class="text-center" [style]="{ 'vertical-align': 'middle' }">
            {{ mOccurrence?.userName }}
          </td>
          <td class="text-center" pTooltip="{{mOccurrence.description}}" tooltipPosition="top" [style]="{ 'vertical-align': 'middle' }">
            {{ mOccurrence?.description }}
          </td>
          <td class="text-center" [style]="{ 'vertical-align': 'middle' }">
            {{ mOccurrence?.equipmentName}}
          </td>
          <td class="text-center" [style]="{ 'vertical-align': 'middle' }">
            {{ mOccurrence?.lane}}
          </td>
          <!-- <td class="text-center" pTooltip="{{mOccurrence.operationDescription}}" tooltipPosition="top" [style]="{ 'vertical-align': 'middle' }">
            {{ mOccurrence.operationDescription }}
          </td> -->
          <td class="text-center" [style]="{ 'vertical-align': 'middle' }">
            {{ mOccurrence?.motiveOccurrence?.description }}
          </td>
          <!-- <td class="text-center" [style]="{ 'vertical-align': 'middle' }">
            {{ returnRejectedLabel(mOccurrence.rejected) }}
          </td> -->
          <td class="text-center" [style]="{ 'vertical-align': 'middle' }">
            {{ mOccurrence?.startDate | date : "dd/MM/yyyy HH:mm"}}
          </td>
          <td class="text-center" [style]="{ 'vertical-align': 'middle' }">
            {{ mOccurrence?.endDate  | date : "dd/MM/yyyy HH:mm" }}
          </td>
          <td class="text-center flex" [style]="{ 'vertical-align': 'middle' }">
            <p-button
              pTooltip="Ver anotações"
              tooltipPosition="top"
              [outlined]="true"
              [rounded]="true"
              icon="pi pi-file"
              severity="info"
              class="mr-2"
              (click)="openNotes(mOccurrence)">
            </p-button>
            <p-button
            pTooltip="Anexar arquivo"
            tooltipPosition="top"
            icon="pi pi-link"
            [outlined]="false"
            [rounded]="true"
            severity="info"
            class="mr-2"
            (click)="showDialog(mOccurrence)">
            </p-button>
            <button
            pButton
            pRipple
            pTooltip="Editar ocorrência"
            tooltipPosition="top"
            icon="pi pi-pencil"
            class="p-button-rounded p-button-secondary mr-2"
            (click)="openEdit(mOccurrence)">
            </button>
            <button pButton pRipple pTooltip="Excluir ocorrência" tooltipPosition="top" icon="pi pi-trash"
              class="p-button-rounded p-button-danger" (click)="openDeleteConfirm(mOccurrence.id, mOccurrence.description)">
            </button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-card>

  <p-dialog
    header="Editar Ocorrência - {{currentOccurrence?.description}}"
    [(visible)]="isVisible"
    [modal]="true"
    [style]="{width: '50vw'}"
    [dismissableMask]="false"
    [closable]="false">

    <div *ngIf="attachments.length > 0" class="mb-4">
      <h5 class="mb-3">
        <i class="pi pi-cloud mr-2"></i>
        Arquivos Salvos ({{ attachments.length - attachmentsToDelete.length }})
      </h5>
      <div class="border-round border-1 surface-border p-3">
        <ul class="list-none p-0 m-0">
          <li
            *ngFor="let attachment of attachments"
            [class.opacity-50]="isMarkedForDeletion(attachment.id)"
            class="flex align-items-center justify-content-between py-2 px-3 mb-2 border-round surface-hover">
            <div class="flex align-items-center">
              <i class="pi pi-file text-primary mr-3 text-xl"></i>
              <div>
                <div class="font-semibold" [class.line-through]="isMarkedForDeletion(attachment.id)">
                  {{ attachment.name }}
                </div>
                <div class="text-sm text-500">
                  {{ attachment.size | fileSize }}
                </div>
                <div class="text-sm text-500">{{attachment.userName}} - {{ attachment.uploadDate | date:'dd/MM/yyyy' }}</div>
              </div>
            </div>
            <div class="flex gap-2">
              <button
                *ngIf="!isMarkedForDeletion(attachment.id)"
                pButton
                pRipple
                icon="pi pi-download"
                class="p-button-rounded p-button-text p-button-info"
                pTooltip="Baixar arquivo"
                tooltipPosition="top"
                (click)="onDownloadAttachment(attachment)">
              </button>
              <button
                *ngIf="!isMarkedForDeletion(attachment.id) && canPreview(attachment.name)"
                pButton
                pRipple
                icon="pi pi-eye"
                class="p-button-rounded p-button-text p-button-info"
                pTooltip="Visualizar arquivo"
                tooltipPosition="top"
                (click)="onPreviewAttachment(attachment)">
              </button>
              <button
                *ngIf="!isMarkedForDeletion(attachment.id)"
                pButton
                pRipple
                icon="pi pi-trash"
                class="p-button-rounded p-button-text p-button-danger"
                pTooltip="Remover arquivo"
                tooltipPosition="top"
                (click)="markAttachmentForDeletion(attachment.id)">
              </button>
              <button
                *ngIf="isMarkedForDeletion(attachment.id)"
                pButton
                pRipple
                icon="pi pi-undo"
                class="p-button-rounded p-button-text p-button-warning"
                pTooltip="Desfazer remoção"
                tooltipPosition="top"
                (click)="unmarkAttachmentForDeletion(attachment.id)">
              </button>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div>
      <h5 class="mb-3">
        <i class="pi pi-upload mr-2"></i>
        Adicionar Novos Arquivos
      </h5>

      <div *ngIf="getActiveAttachmentsCount() >= MAX_ATTACHMENTS" class="mb-3 p-3 border-round bg-yellow-50 text-yellow-900">
        <i class="pi pi-exclamation-triangle mr-2"></i>
        Limite de {{MAX_ATTACHMENTS}} anexos atingido
      </div>

      <p-fileUpload
        #fileUpload
        name="files[]"
        chooseLabel="Escolher"
        [multiple]="true"
        accept=".pdf,.jpg,.jpeg,.png,.webp,.mp4,.mov,.csv,.xlsx,.docx,.txt,.json,.log,.zip"
        [maxFileSize]="MAX_FILE_SIZE"
        invalidFileSizeMessageSummary="Arquivo muito grande"
        [invalidFileSizeMessageDetail]="'O tamanho máximo permitido é de ' + (MAX_FILE_SIZE / (1024 * 1024)) + ' MB'"
        (onSelect)="onFileSelect($event)"
        [showUploadButton]="false"
        [showCancelButton]="false"
        [auto]="false"
        [customUpload]="true"
        [disabled]="getActiveAttachmentsCount() >= MAX_ATTACHMENTS"
        [files]="uploadedFiles"
        invalidFileTypeMessageSummary="{0}: Tipo de arquivo inválido."
         invalidFileTypeMessageDetail="Tipos de arquivos permitidos: pdf, jpg, jpeg, png, webp, mp4, mov, csv, xlsx, docx, txt, json, log, zip.">
        <ng-template pTemplate="content">
          <div *ngIf="uploadedFiles.length === 0" class="text-center p-4">
            <i class="pi pi-cloud-upload text-4xl text-400"></i>
            <p class="mt-3 text-500">
              {{ getActiveAttachmentsCount() >= MAX_ATTACHMENTS ?
                 'Limite de anexos atingido' :
                 'Arraste arquivos aqui ou clique para selecionar' }}
            </p>
          </div>

          <ul *ngIf="uploadedFiles.length > 0" class="list-none p-0 m-0">
            <li
              *ngFor="let file of uploadedFiles; let i = index"
              class="flex align-items-center justify-content-between py-2 px-3 mb-2 border-round surface-hover">
              <div class="flex align-items-center">
                <i class="pi pi-file text-blue-500 mr-3 text-xl"></i>
                <div>
                  <div class="font-semibold">{{ file.name }}</div>
                  <div class="text-sm text-500">
                    {{ file.size | fileSize }}
                  </div>
                </div>
              </div>
              <div class="flex gap-2">
                <button
                  *ngIf="canPreview(file.name)"
                  pButton
                  pRipple
                  icon="pi pi-eye"
                  class="p-button-rounded p-button-text p-button-info"
                  pTooltip="Visualizar arquivo"
                  tooltipPosition="top"
                  (click)="onPreviewFile(file)">
                </button>
                <button
                  pButton
                  pRipple
                  icon="pi pi-times"
                  class="p-button-rounded p-button-text p-button-danger"
                  pTooltip="Remover"
                  tooltipPosition="top"
                  (click)="removeNewFile(i)">
                </button>
              </div>
            </li>
          </ul>
        </ng-template>
      </p-fileUpload>
    </div>

    <ng-template pTemplate="footer">
      <div class="flex justify-content-between align-items-center w-full">
        <div class="text-sm text-500">
          Total: {{ getActiveAttachmentsCount() }} / {{ MAX_ATTACHMENTS }} arquivo(s)
        </div>
        <div class="flex gap-2">
          <button
            pButton
            label="Cancelar"
            icon="pi pi-times"
            class="p-button-text"
            (click)="cancelDialog()"
            [disabled]="loading">
          </button>
          <button
            pButton
            label="Salvar"
            icon="pi pi-check"
            (click)="saveAttachments()"
            [disabled]="loading || (attachmentsToDelete.length === 0 && uploadedFiles.length === 0)"
            [loading]="loading">
          </button>
        </div>
      </div>
    </ng-template>
  </p-dialog>

  <p-dialog
    *ngIf="preview"
    [header]="preview.fileName"
    [(visible)]="preview.visible"
    [modal]="true"
    [closable]="true"
    [style]="{width: '80vw'}"
    [contentStyle]="{'height': '70vh'}"
    (onHide)="closePreview()">
    <p-skeleton *ngIf="preview.loading" width="100%" height="100%"></p-skeleton>

    <ng-container *ngIf="!preview.loading" [ngSwitch]="preview.kind">
      <img
        *ngSwitchCase="'image'"
        style="width: 100%; height: 100%; object-fit: contain; display: block"
        [src]="preview.objectUrl"
        [alt]="preview.fileName">

      <iframe
        *ngSwitchCase="'pdf'"
        style="width: 100%; height: 100%; border: 0"
        [src]="preview.safeResourceUrl"
        [title]="preview.fileName">
      </iframe>

      <pre
        *ngSwitchCase="'json'"
        style="height: 100%; margin: 0; padding: 1rem; overflow: auto; white-space: pre-wrap; word-break: break-word">{{ preview.text }}</pre>

      <div *ngSwitchCase="'xlsx'" style="height: 100%; overflow: auto">
        <table style="width: 100%; border-collapse: collapse; font-size: 0.875rem">
          <tbody>
            <tr *ngFor="let row of preview.rows">
              <td
                *ngFor="let cell of row"
                style="min-width: 120px; max-width: 320px; padding: 0.5rem; border: 1px solid #e5e7eb; white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{ cell }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>
  </p-dialog>

  <app-not-found-component
  *ngIf="notFound"
  [titulo]="tituloNotFound"
  [descricao]="descricaoNotFound"
  ></app-not-found-component>

  <p-dialog
    header="Anotações - {{ selectedNotesDescription }}"
    [(visible)]="isNotesVisible"
    [modal]="true"
    [style]="{width: '40vw'}"
    [dismissableMask]="false"
    [closable]="false">
    <div class="py-2">
      <textarea
        pInputTextarea
        class="min-w-full"
        [(ngModel)]="selectedNotes"
        [rows]="6"
        [autoResize]="true">
      </textarea>
      <p *ngIf="!selectedNotes" class="text-500 text-center mt-3">
        <i class="pi pi-info-circle mr-2"></i>Nenhuma anotação registrada.
      </p>
    </div>
    <ng-template pTemplate="footer">
      <div class="flex justify-content-end gap-2">
        <button
          pButton
          type="button"
          title="Cancelar"
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-text"
          (click)="cancelNotes()"
          [disabled]="notesLoading">
        </button>
        <button
          pButton
          type="button"
          title="Salvar"
          label="Salvar"
          icon="pi pi-check"
          (click)="saveNotes()"
          [disabled]="notesLoading || !hasNotesChanged()"
          [loading]="notesLoading">
        </button>
      </div>
    </ng-template>
  </p-dialog>

  <p-confirmDialog [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '50vw'}"></p-confirmDialog>
</div>
